import { Text } from "@/components/ui/Text";
import { classed } from "@frend-digital/ui";
import styles from "./index.module.css";

export const Section = classed("section", styles.section);

export const SectionTitle = ({
	children,
	name,
}: {
	children: React.ReactNode;
	name: string;
}) => {
	return (
		<Text variant="utility4" className={styles.sectionTitle}>
			<Text variant="utility4" asChild bold>
				<span>{name}</span>
			</Text>{" "}
			<span>{children}</span>
		</Text>
	);
};
